// import React, { useRef, useState } from "react";

// import { Swiper, SwiperSlide } from "swiper/react";

// import { EffectCards } from "swiper";

// import BankCard from "../../Shared/BankCard";
// import { styled } from "@mui/material";

// import './styles.css'

// const StyledSwiper = styled(Swiper)({
//   height: '237px',
//   width: '330px'
// })
// const StyledSwiperSlide = styled(SwiperSlide)({
//   display: 'flex',
//   padding: '10px',
//   alignItems: 'center',
//   justifyContent: 'center',
// })

// const CardCarousel = () => {

//   return (
//     <div>
//       <StyledSwiper
//         direction="vertical"
//         effect={"cards"}
//         watchOverflow={true}
//         cardsEffect={{
//           rotate: false,
//           slideShadows: false
//         }}
//         grabCursor={true}
//         modules={[EffectCards]}
//         className="mySwiper"
//         mousewheel={true}
//         // initialSlide={4}
//       >
//         <SwiperSlide>
//           <BankCard />
//         </SwiperSlide>
//         <SwiperSlide >
//           <BankCard />
//         </SwiperSlide>
//         <SwiperSlide >
//           <BankCard />
//         </SwiperSlide>
//         <SwiperSlide >
//           <BankCard />
//         </SwiperSlide>
//       </StyledSwiper>
//     </div>
//   );
// }

// export default CardCarousel

import {Swiper, SwiperSlide} from "../../../packages/swiper/react";

// Import Swiper styles
import "../../../packages/swiper/swiper-bundle.css";
// import "swiper/css/effect-cards";
import "./styles.css";

// import required modules
import {EffectCards} from "../../../packages/swiper";
import BankCard from "../../Shared/BankCard";
import shortid from "shortid";
// import { Dispatch, memo, SetStateAction } from "react";

const CardCarousel = ({
                          arrayData,
                          setActiveSlide,
                      }: {
    arrayData: any[];
    setActiveSlide: (index: number) => void;
}) => {
    return (
        <>
            <Swiper
                effect={"cards"}
                grabCursor={true}
                modules={[EffectCards]}
                className="mySwiper"
                direction="vertical"
                cardsEffect={{
                    rotate: false,
                    gap: 25,
                    slideShadows: false,
                }}
                initialSlide={arrayData.length}
                // onSlideChangeTransitionEnd={(index) => {
                //   setActiveSlide(index.activeIndex);
                // }}
                onSlideChange={(index) => {
                    setActiveSlide(index.activeIndex);
                }}
            >
                {arrayData.map((item, key) => (
                    <SwiperSlide key={shortid.generate()}>
                        <BankCard itemKey={arrayData.length - key - 1} item={item}/>
                    </SwiperSlide>
                ))}
            </Swiper>
        </>
    );
};

export default CardCarousel;
